import { State } from '../state/State.type'
import { randomId } from '../util/rand'

export default function nextEntityIdFromEngine(state: State): number {
  const { ents, rng } = state
  const id: number = randomId(ents, rng)
  return id
}
